import {
  Checkbox,
  FormControl,
  ListItemText,
  MenuItem,
  Select,
  useTheme,
} from '@mui/material';
import { tokens } from '../theme';
import { pluralize } from '../utils/helper';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  disableAutoFocusItem: true,
};

const MultipleSelect = ({
  allText,
  options,
  selectedOption,
  onChangeOptions,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const handleChange = (evt) => {
    const {
      target: { value },
    } = evt;
    if (value.includes('all')) {
      onChangeOptions(
        selectedOption.length === options.length
          ? []
          : options.map((item) => item.id)
      );
    } else {
      onChangeOptions(value);
    }
  };

  const handleRenderValue = (selected) => {
    if (
      selected.length === 0 ||
      selected.includes('all') ||
      selected.length >= optLength
    ) {
      return <em>{allText}</em>;
    }

    const optNames = options
      .filter(({ id }) => selectedOption.includes(id))
      .map((item) => item.name);

    const [opt1, opt2, ...remaining] = optNames;
    const opts = opt2 ? [opt1, opt2] : [opt1];

    if (remaining.length > 0) {
      opts.push('+' + pluralize('other', remaining.length, true));
    }

    return opts.join(', ');
  };

  const selectedOptsLength = selectedOption.length;
  const optLength = options.length;

  return (
    <FormControl
      variant="outlined"
      size="small"
      sx={{ minWidth: 220, maxWidth: 220 }}>
      <Select
        multiple
        displayEmpty
        value={selectedOption}
        MenuProps={MenuProps}
        onChange={handleChange}
        renderValue={handleRenderValue}
        sx={{
          backgroundColor: colors.primary[400],
          borderRadius: 1,
          maxHeight: 400,
        }}>
        <MenuItem value="all" name="all" sx={{ pr: 0, pl: 0.5 }}>
          <Checkbox
            checked={
              selectedOption.includes('all') || selectedOptsLength === optLength
            }
            indeterminate={
              selectedOptsLength > 0 && selectedOptsLength < optLength
            }
          />
          <ListItemText primary={allText} />
        </MenuItem>
        {options.map((opt) => (
          <MenuItem key={opt.id} value={opt.id} sx={{ pr: 0, pl: 0.5 }}>
            <Checkbox checked={selectedOption.includes(opt.id)} />
            <ListItemText primary={opt.name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MultipleSelect;
